function format(value, type, suffix, numberOfDecimals, separator = "", maxNumberOfDecimals = 2) {
    // console.log(value.trim(), suffix.trim())
    var numberTypes = ["number", "integer", "decimal"];

    if (value.length === 0) return "";
    else if (numberTypes.indexOf(type) !== -1) {
        let parsedSuffix = suffix ? prefixed(suffix, suffix[0] === "+" ? "" : " ") : ""
        return formatNumber(value, numberOfDecimals, separator, maxNumberOfDecimals) + parsedSuffix;
    }
    else if (type === "bool") return formatBool(value);
    else return value + prefixed(suffix, " ");
}

format.currency = function(value) {
    return format(value, "number", "kr", 0, " ");
};


exports.formatter = function() {
    return format;
};

function formatBool(value) {
    return value ? "ja" : "nei";
}

function formatNumber(value, numberOfDecimals, separator, maxNumberOfDecimals) {
    var withoutMinus = String(value).replace(/^-/, "");
    var fixed = decimalToFixedPoint(withoutMinus, numberOfDecimals);
    var containsDecimalPoint = fixed.match(/\./);
    var isNegativeNumber = value < 0;

    var splitOnDecimalPoint = String(fixed).split(".");
    var [integerPart, fractionalPart] = splitOnDecimalPoint;

    return (isNegativeNumber ? "-" : "") +
        insertThousandSeparators(integerPart, separator) +
        (containsDecimalPoint ? "," + fractionalPart.substr(0, maxNumberOfDecimals) : "");
}

function insertThousandSeparators(value, separator) {
    var reversed = Array.prototype.slice.call(String(value), 0).reverse();
    return reversed.reduce(function makeListOfCharacters(list, character, index) {
        if (index !== 0 && index % 3 === 0) list.push(separator);
        list.push(character);
        return list;
    }, []).reverse().join('');
}

function decimalToFixedPoint(value, numberOfDecimals) {
    var exponential = 'e' + numberOfDecimals;
    var negativeExponential = 'e-' + numberOfDecimals;

    if (numberOfDecimals === undefined) return String(value);
    else if (value < 1e-5) {
        return String(Math.round(value));
    }
    else {
        var roundedNumber = Number(Math.round(value + exponential) + negativeExponential);
        return roundedNumber.toFixed(numberOfDecimals);
    }
}

function prefixed(text, prefix) {
    return text ? prefix + text : "";
}


